import { defineStore } from "pinia"
import { ref, type Ref } from "vue"
import { SaleItem } from "@/models/sale-item.model"
import { useStoreBaseFunctions } from "@/composables/store/store-base-functions"
import { SaleItemRepository } from "@/repositories/sale-item-repository"
import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"

export const useSaleItemStore = defineStore("saleItemStore", () => {
  const saleItems: Ref<SaleItem[]> = ref([])

  useSocketSynchronizationHandlers(SaleItem, saleItems)

  const { fetchModels: fetchSaleItems, saveModel: saveSaleItem } = useStoreBaseFunctions(
    SaleItem,
    SaleItemRepository,
    saleItems
  )

  return {
    saleItems,
    fetchSaleItems,
    saveSaleItem
  }
})
